import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core'
import styles from './styles'

import moment from 'moment'

const FileMessage = ({ classes, message }) => {
    const innerMessage = message?.message || {}
    const { text, timestamp } = innerMessage

    const displayDate = timestamp ? moment(timestamp).format('DD/MM/YYYY') : 'Unknown Date'
    const displayTitle = text || 'Meeting notes'

    return (
        <div className={classes.container}>
            <div className={classes.innerContainer}>
                <span className={classes.title}>{displayTitle}</span>
                <span className={classes.date}>{displayDate}</span>
            </div>
        </div>
    )
}

FileMessage.propTypes = {
    classes: PropTypes.object.isRequired,
    message: PropTypes.object,
}

export default withStyles(styles)(FileMessage)
